export * from './config';



// WEBPACK FOOTER //
// src/etc/config/index.js